  import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Images } from '../assets/Oraimos';
const Order = () => {
  const [ OpenReview, setOpenReview ] = useState(false)
  const HandleReview = () => {
    window.location.href = "https://wa.link/ari1rd";
  };
  
  
  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-gray-100 p-6">
      <div className='flex gap-3 p-2 top-3 items-center justify-center font-semibold'>
        <span className='hover:text-orange-500 text-orange-700 hover:underline'>Product 1</span>
        <Link to="/Order2"><span className='hover:text-orange-500 hover:underline'>Product 2</span></Link>
      </div>
      <div className="flex flex-col md:flex-row gap-6 items-start bg-white shadow-lg rounded-lg p-6 w-full max-w-4xl">
        {/* Product Image */}
        <div className="flex-shrink-0 items-center justify-center">
          <img 
            src="https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/89/8491651/1.jpg?9655" 
            alt="Oraimo 20000mAh Powerbank" 
            className="rounded-lg w-full h-[270px] object-cover"
          />
        </div>

        {/* Product Details */}
        <div className="flex flex-col gap-4 flex-grow">
          {/* Product Title */}
          <div>
            <h1 className="text-2xl font-semibold text-gray-800 leading-tight">
              Oraimo 20000mAh Powerbank
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              Type-C & Micro-USB Input | Fast Charging
            </p>

          </div>

          {/* Price */}
          <div className="text-xl font-bold text-blue-600 mt-2">
            ₦ 22,200 <strike className="text-gray-300"><span className='text-gray-400 '>₦ 30,000</span></strike>
          </div>

          {/* Add to Cart Button */}
          <div className="mt-6">
            <Link to="/checkout"><button 
              className="text-white font-semibold bg-blue-500 p-3 rounded-lg w-full shadow-lg hover:bg-blue-600 transition duration-300"
            >
              Add to Cart
            </button></Link>
            <div className="flex gap-3 items-center justify-between p-3">
            <div>
              <img src="data:image/jpeg;base64,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" alt="PowerBank 20000mAh Oriamo" 
              className="h-[100px]"
              />
            </div>
            <div>
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTT9FyZJ0tOImbYNXqVERYtpSo00VnT_szxVg&s" alt="powerBank" className="h-[100px] rounded-lg"/>
            </div>
            <div>
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSABiI65wzt5B5QD1vzBrswNRibPZ5r3jpwWA&s" alt="powerBank" className="h-[100px] rounded-lg"/>
            </div>
            <div>
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAU0w2uxK12KmI3u3tNln1Qn_w44zq-tvWzg&s" alt="powerBank" className="h-[100px] rounded-lg"/>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        {Images.map((item)=>(
          <div key={item.id} className='flex gap-2 flex-col items-center justify-center p-3 mt-6'>
            <img src={item.image} alt="Power bank images" className=' lg:w-[939px] rounded-lg'/>
          </div>
        ))}
      </div>
     
        <div className="flex flex-col gap-8 bg-white shadow-lg rounded-lg p-6 w-full max-w-4xl mt-8 mx-auto">
  {/* Product Description */}
  <div>
    <h1 className="text-2xl font-semibold text-gray-800 mb-2">Product Description</h1>
    <p className="text-gray-600 leading-relaxed">
      20000mAh High Capacity: Say Goodbye to Battery Anxiety - 20000mAh large capacity, filled to the brim with power. 
      It lasts up to a week on a single charge, so whether you're on a personal business trip or a family trip, you just need one.
    </p>
  </div>

  {/* Customer Reviews Section */}
  <div>
    <h2 className="text-2xl font-semibold text-gray-800 mb-4">Customer Reviews</h2>

    {/* Individual Reviews */}
    <div className="flex flex-col gap-6">
      {/* Review 1 */}
      <div className="border-b pb-4">
        <h3 className="text-lg font-medium text-gray-700">John Doe</h3>
        <p className="text-sm text-gray-600">⭐⭐⭐⭐☆</p>
        <p className="text-gray-600 mt-2">
          This power bank is amazing! It lasts for days and charges my devices very quickly. Highly recommend it.
        </p>
      </div>

      {/* Review 2 */}
      <div className="border-b pb-4">
        <h3 className="text-lg font-medium text-gray-700">Jane Smith</h3>
        <p className="text-sm text-gray-600">⭐⭐⭐⭐⭐</p>
        <p className="text-gray-600 mt-2">
          Absolutely love this product! It’s compact and perfect for traveling. The capacity is exactly as advertised.
        </p>
      </div>

      {/* Placeholder for Adding More Reviews */}
      <div className="text-center mt-6">
     
        {OpenReview ? <div className='flex flex-col gap-4 mt-5'><textarea placeholder='Write a review' className='border-2 border-black p-2'></textarea>
        <button className='w-full text-white bg-blue-500 p-2 rounded-lg font-bold'
        onClick={setOpenReview(false)}
        >Submit
        </button>
        </div> : <button className="bg-blue-500 text-white font-semibold px-6 py-2 rounded-lg shadow-md hover:bg-blue-600 transition duration-300"
        onClick={HandleReview}
        >
          Add Your Review
        </button>}
      </div>
    </div>
  </div>
</div>

    </div>
  );
};

export default Order;
